
  var _styles = {
  "main-filter-container": {
    "width": "8.05333rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "borderRadius": "0.4rem 0.4rem 0 0"
  },
  "round-bar-container": {
    "width": "8.05333rem",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "position": "relative",
    "background": "#fff",
    "borderRadius": "0.48rem",
    "height": "0.90667rem",
    "display": "flex",
    "alignItems": "center",
    "flexDirection": "row",
    "flexGrow": 1
  },
  "main-filter-text-container": {
    "display": "flex",
    "width": "0.26667rem",
    "flexDirection": "column",
    "marginLeft": "0.32rem",
    "justifyContent": "space-between"
  },
  "main-filter-left-text": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(102,102,102)",
    "lineHeight": "0.29333rem"
  },
  "main-filter-date-container": {
    "display": "flex",
    "justifyContent": "space-between",
    "marginLeft": "0.08rem"
  },
  "main-filter-date-text": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.26667rem",
    "color": "rgb(0,64,153)",
    "lineHeight": "0.29333rem"
  },
  "main-filter-vertical-line": {
    "height": "0.53333rem",
    "width": "0.02667rem",
    "marginTop": "0.21333rem",
    "marginRight": "0.21333rem",
    "marginBottom": "0.21333rem",
    "marginLeft": "0.21333rem",
    "verticalAlign": "middle",
    "backgroundColor": "rgb(226,226,226)"
  },
  "main-filter-search-icon": {
    "width": "0.48rem",
    "height": "0.48rem"
  },
  "main-filter-input": {
    "marginLeft": "0.05333rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(0,0,0)",
    "lineHeight": "0.42667rem",
    "minWidth": "4.26667rem",
    "maxWidth": "4.26667rem",
    "paddingLeft": 0
  },
  "main-filter-clear-icon": {
    "width": "0.45333rem",
    "height": "0.45333rem"
  },
  "main-filter-clear-text": {
    "position": "absolute",
    "right": "0.2rem",
    "backgroundColor": "rgba(224,215,215,0.4)",
    "borderRadius": "0.22667rem"
  },
  "main-filter-location-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.8rem"
  },
  "main-filter-location-text": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "lineHeight": "0.42667rem"
  },
  "main-filter-location-icon-down": {
    "width": "0.32rem",
    "height": "0.32rem",
    "marginLeft": "0.02667rem"
  },
  "main-filter-search-button": {
    "width": "1rem",
    "height": "0.53333rem",
    "position": "absolute",
    "right": "0.2rem",
    "backgroundColor": "rgb(0,64,153)",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "0.32rem"
  },
  "main-filter-search-button-text": {
    "fontSize": "0.29333rem",
    "color": "rgb(255,255,255)"
  },
  "search-input-wrap": {
    "position": "relative"
  },
  "search-input-mask": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "bottom": 0,
    "right": 0,
    "width": "100%",
    "zIndex": 1
  }
};



  module.exports = _styles;
  